import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Checkbox, Select, Spin, Table, Card, Tag, Tooltip, Icon,
} from 'antd';
import { changeBikeModelListRequest } from '../../Bike_model_update/redux/actions/change_bike_model.actions';
import { statics } from './statics';
import { getVal, trim, allFalse } from '../../../../shared/helpers';

import { searchBikesRequest, setBikeManagementFilter, setBikeManagementKey } from '../redux/actions/search_bikes.actions';

const mapStateToProps = (state) => {
    const {
        isShow, amount, where, pagination, bikes_found, filters,
    } = state.PlatformManagement.Bike_management;
    return {
        isShow, amount, where, pagination, bikes_found, filters,
    };
};

const { Option } = Select;
const { Column } = Table;

// const { page, pageSize, where, pagination } = state.PlatformManagement.Bike_management;
// updateData = () => this.props.dispatch(getBikeModelsRequest(this.props.where, this.props.pagination))
// resetData = () =>
// {
//     this.props.dispatch({ type: 'RESET_ALL_FILTERS' })
//     this.props.dispatch(getBikeModelsRequest({}, { page: 0, pageSize: 10 }))
// }
// model_update_access = views_permissions['view://PlatformManagement/Bike_model_update']
{ /* <Tooltip title="Reset"> */
}
{ /* <Icon type="undo" style={{color: 'red'}} onClick={this.resetData}/> */
}
{ /* </Tooltip> */
}
{ /* <Tooltip title="Refresh"> */
}
{ /* <Icon type="sync" style={{marginLeft: 20, color: 'gray'}} onClick={this.updateData}/> */
}
{ /* </Tooltip> */
}

{ /* <BikeList model_update_access={!model_update_access} /> */
}

export default connect(mapStateToProps)(class BikeList extends Component {
    handleChange = (value, key, model_id) => this.props.dispatch(changeBikeModelListRequest(model_id, key, value));

    handleChangePage = (page, pageSize) => {
        this.props.dispatch(setBikeManagementKey({ path: 'pagination', value: { page, pageSize } }));
        this.props.dispatch(searchBikesRequest());
    };

    backToSearch = () => this.props.dispatch({ type: 'SHOW_TABLE', payload: false });

    handleClose = (key) => {
        this.props.dispatch(setBikeManagementFilter({ db_key: key, value: undefined }));
        this.props.dispatch(searchBikesRequest());
    };


    setValue = (key) => {
        if (this.props.filters) {
            if (this.props.filters[key].value !== undefined || this.props.filters[key].value !== null) {
                if (key === 'ref_bike_brand') {
                    return getVal(this.props.bikes_found, '0.ref_bike_brand.0.name') && ` : ${this.props.bikes_found[0].ref_bike_brand[0].name}`;
                } if (key === 'ref_bike_model') {
                    return getVal(this.props.bikes_found, '0.name') && ` : ${this.props.bikes_found[0].name}`;
                }
                return (this.props.filters[key].value === true || this.props.filters[key].value === false) ? '' : ` : ${String(this.props.filters[key].value)}`;
            }
        }
    };

    render() {
        const tags = !allFalse(this.props.filters) ? Object.keys(this.props.filters) : [];

        const activeFilters = this.props.filters && Object.keys(this.props.filters).filter(
            filter => this.props.filters[filter].value !== false && this.props.filters[filter].value !== undefined,
        );

        const components = {
            body: {
                wrapper: () => (
                    <tbody>
                        {this.props.bikes_found && this.props.bikes_found.map(model => (
                            <tr key={model._id} style={{ textAlign: 'center', height: 58, borderBottom: '1px solid #d9d9d9bd' }}>
                                <td>
                                    <Link to={
                                        !this.props.model_update_access
                                            ? { pathname: `/PlatformManagement/Bike_model_update/${trim(model._id)}`, state: { id: model._id } }
                                            : { pathname: '' }}
                                    >
                                        {model.ref_bike_brand[0].name}
                                        {' '}
                                        {model.name}
                                        {' '}
                                        {model.cc ? `${model.cc}cc` : ''}
                                    </Link>
                                </td>
                                <td>
                                    <Select
                                        style={{ width: '45%' }}
                                        value={model.wwym_priority}
                                        onChange={value => this.handleChange(value, 'wwym_priority', model._id)}
                                    >
                                        {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                    </Select>
                                </td>
                                <td>
                                    <Select
                                        style={{ width: '45%' }}
                                        value={model.leadomatic_priority}
                                        onChange={value => this.handleChange(value, 'leadomatic_priority', model._id)}
                                    >
                                        {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                    </Select>
                                </td>
                                <td>
                                    <Select
                                        style={{ width: '80%' }}
                                        value={model.mileage_limit === 0 ? 'Not Set' : model.mileage_limit}
                                        onChange={value => this.handleChange(value, 'mileage_limit', model._id)}
                                    >
                                        {statics.bike_mileage_limit.map(limit => <Option key={limit.value}>{limit.label}</Option>)}
                                    </Select>
                                </td>
                                <td>
                                    <Select
                                        style={{ width: '90%' }}
                                        value={model.min_age === 0 ? 'Not Set' : model.min_age}
                                        onChange={value => this.handleChange(value, 'min_age', model._id)}
                                    >
                                        {statics.bike_min_age.map(age => <Option key={age.value}>{age.label}</Option>)}
                                    </Select>
                                </td>
                                <td>
                                    <Checkbox
                                        style={{ width: 17 }}
                                        onChange={event => this.handleChange(event.target.checked, 'we_dont_want', model._id)}
                                        checked={model.we_dont_want}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ),
            },
        };


        return (
            <Spin spinning={this.props.loading} tip="Loading ...">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        {
                            (activeFilters && activeFilters.length)
                                ? (
                                    <Fragment>
                                        {activeFilters.map((filter, index) => {
                                            if (getVal(this.props.filters, filter)) {
                                                return (
                                                    <Tag key={index} closable onClose={() => this.handleClose(filter)}>
                                                        {this.props.filters[filter].display_name}
                                                        {this.setValue(filter)}
                                                    </Tag>
                                                );
                                            }
                                            return [];
                                        })}
                                    </Fragment>
                                )
                                : <Tag>No active filters</Tag>
                        }
                    </div>
                    <p
                        style={{
                            margin: '0 0 15px 0', fontSize: 16, fontWeight: 600, cursor: 'pointer',
                        }}
                        onClick={this.backToSearch}
                    >
                        Amend Search
                    </p>
                </div>
                <Card className="border-shadows">
                    <Table
                        components={components}
                        rowKey="_id"
                        pagination={{
                            defaultCurrent: 1,
                            total: this.props.amount,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            current: this.props.pagination.page,
                            pageSize: this.props.pagination.pageSize,
                            pageSizeOptions: ['10', '25', '50', '100'],
                            onChange: this.handleChangePage,
                            onShowSizeChange: this.handleChangePage,
                        }}
                    >
                        <Column
                            align="center"
                            title="Bike"
                            key="ref_bike_brand"
                            dataIndex="ref_bike_brand"
                        />
                        <Column
                            align="center"
                            title="We Want Priority"
                            key="wwym_priority"
                            dataIndex="wwym_priority"
                        />
                        {statics.titles.map(item => <Column align="center" title={item.title} dataIndex={item.dataIndex} key={item._id} />)}
                        <Column
                            align="center"
                            title="We Don`t Want"
                            key="we_dont_want"
                            dataIndex="we_dont_want"
                        />
                    </Table>
                </Card>
            </Spin>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/components/BikeList.js